export default "__VITE_ASSET__C5Tj90HK__"